import React from 'react';
import styles from './LabIcon.module.css';

interface LabIconProps {
  size: number;
}

const LabIcon = ({ size }: LabIconProps) => {
  return (
    <span
      style={{
        width: `${size}px`,
        height: `${size}px`,
      }}
      className={styles.labIcon}
    >
      <svg width="10" height="14" viewBox="0 0 10 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          className={styles.labIconPath}
          d="M5 13.6667C4.07777 13.6667 3.29166 13.3417 2.64166 12.6917C1.99166 12.0417 1.66666 11.2556 1.66666 10.3333V4.33333C1.29999 4.33333 0.986106 4.20277 0.724995 3.94166C0.463884 3.68055 0.333328 3.36666 0.333328 2.99999V1.66666C0.333328 1.29999 0.463884 0.986106 0.724995 0.724995C0.986106 0.463884 1.29999 0.333328 1.66666 0.333328H8.33333C8.7 0.333328 9.01388 0.463884 9.275 0.724995C9.53611 0.986106 9.66666 1.29999 9.66666 1.66666V2.99999C9.66666 3.36666 9.53611 3.68055 9.275 3.94166C9.01388 4.20277 8.7 4.33333 8.33333 4.33333V10.3333C8.33333 11.2556 8.00833 12.0417 7.35833 12.6917C6.70833 13.3417 5.92222 13.6667 5 13.6667ZM1.66666 2.99999H8.33333V1.66666H1.66666V2.99999ZM5 12.3333C5.55555 12.3333 6.02777 12.1389 6.41666 11.75C6.80555 11.3611 7 10.8889 7 10.3333H5V9H7V7.66666H5V6.33333H7V4.33333H2.99999V10.3333C2.99999 10.8889 3.19444 11.3611 3.58333 11.75C3.97222 12.1389 4.44444 12.3333 5 12.3333Z"
        />
      </svg>
    </span>
  );
};

export default LabIcon;
